<template>
    <form>
        <div class="icon">
            <SvgIcon icon="search"/>
        </div>
        <input type="text"
               v-debounce:300ms="commit"
               autocomplete="false"
               :placeholder="$t('search.filterplaceholder')"
        />
    </form>
</template>

<script>
export default {
    name: "InputSearch",
    methods: {
        commit(value) {
            this.$emit('input', value)
        }
    }
}
</script>

<style scoped>

</style>
